import * as React from 'react';
import {Component, deps, inject, observer} from '../lib/component';
import {Loading} from '../components/loading/loading';
import {centerCenter} from 'csstips';
import {style} from 'typestyle';
import {PageAttribution} from '../components/page-attribution';
import MainWrapper from '../components/main-wrapper';

export interface AccountAttributionPageProps {

}

@inject(deps) @observer
export class AccountAttributionPage extends Component<AccountAttributionPageProps> {
  render() {
    const model = this.props.model.page.accountAttribution;

    if (model.loading) return (
      <MainWrapper className={AccountAttributionPage.styles.loading}>
        <Loading />
      </MainWrapper>
    );

    return (
      <PageAttribution model={model} />
    )
  }

  componentWillMount() {
    this.props.controller.ui.setChrome(false);
  }

  componentWillUnmount() {
    this.props.controller.ui.setChrome(true);
  }

  static styles = {
    loading: style({
      ...centerCenter,
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    })
  }
}